<template>
	<div class="column-item" @drop="drop($event, index)" @dragend="dragLeave($event)" @dragover.prevent @dragenter.prevent>
		<div class="column-header-container py-2">
			<div class="column-header px-2">
				<span class="remove-item-icon" @click="remove()"><i class="fas fa-times"></i></span>
				<input type="text" class="alias-input" v-model="localData.alias" placeholder="نام نمایشی را وارد کنید" />
				<span class="move-item-icon" draggable="true" @dragstart="dragStart($event, index)"><i class="fas fa-arrows-left-right"></i></span>
			</div>
		</div>
		<div class="column-body-container py-2">
			<div class="column-body px-2 py-4">
				<div class="column-title">
					<div>{{ localData.titlePath }}</div>
					<div>
						<select v-if="localData.type && localData.type.toLowerCase() === 'datetime'" v-model="localData.dateGrouping" class="qd-dropdown">
							<option value="0"></option>
							<option value="1">روزانه</option>
							<option value="2">روزهای هفته</option>
							<option value="4">هفتگی</option>
							<option value="3">ماهانه</option>
							<option value="5">سالانه</option>
						</select>
					</div>
				</div>
				<div>
					<div class="column-aggregate my-4" v-if="localData.fromVariable">
						<div>اطلاعات کدام ستون نمایش داده شود:</div>
						<select v-model="localData.fromVariable.targetColumn" class="qd-dropdown">
							<option value=""></option>
							<option v-for="ct in variableTargetColumns" :key="ct.key" :value="ct.key">
								{{ ct.title }}
							</option>
						</select>

						<div>کاراکتر جدا ساز:</div>
						<input class="qd-input limit-input" type="text" v-model="localData.fromVariable.separator">

						<div>انطباق از ستون:</div>
						<select v-model="localData.fromVariable.left" class="qd-dropdown">
							<option value=""></option>
							<option v-for="ct in reportColumns" :key="ct.key" :value="ct.key">
								{{ ct.title }}
							</option>
						</select>

						<div>انطباق به ستون:</div>
						<select v-model="localData.fromVariable.right" class="qd-dropdown">
							<option value=""></option>
							<option v-for="ct in variableTargetColumns" :key="ct.key" :value="ct.key">
								{{ ct.title }}
							</option>
						</select>

					</div>
				</div>
				<div class="column-aggregate my-4">
					تجمیع:
					<select v-model="localData.aggregate" class="qd-dropdown">
						<option value=""></option>
						<option value="count">تعداد</option>
						<option value="sum">مجموع</option>
						<option value="min">کمترین</option>
						<option value="max">بیشترین</option>
						<option value="avg">میانگین</option>
					</select>
				</div>
				<div class="column-options">
					<Toggler v-model="localData.hidden" :options="{ title: 'مخفی' }"></Toggler>
					<Toggler v-model="localData.distinct" :disabled="Number(index) > 0 && !modelValue.aggregate" :options="{ title: 'Distinct' }" class="mr-3"></Toggler>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Toggler from '../components/general/toggler.vue'

	export default {
		name: 'columns-table-row',
		components: {
			Toggler
		},
		props: {
			modelValue: {
				type: Object,
			},
			index: {
				type: String,
			},
			variables: {
				type: Array,
				default: () => [],
			},
			fields: {
				type: Array,
				default: () => [],
			}
		},
		emits: ['remove', 'update:modelValue', 'swap-items'],
		data() {
			return {
				localData: {},
			}
		},
		created() {
			this.localData = { ...this.modelValue }

			if (this.localData.hidden === undefined)
				this.localData.hidden = false

			if (this.localData.distinct === undefined)
				this.localData.distinct = false
		},
		watch: {
			localData: {
				deep: true,
				handler() {
					this.$emit('update:modelValue', this.localData)
				},
			},
		},
		computed: {
			variableTargetColumns() {
				let items = []
				this.variables.find(x => x.key === this.localData.fromVariable?.variableKey)?.dynamicValue.columns.forEach((col) => {
					items.push({
						title: `${col.alias ? col.alias : col.titlePath}`,
						key: `${col.path}`,
					})
				})
				return items
			},
			reportColumns() {
				let items = []
				let mapped = this.fields.filter(x => !x.fromVariable).map((v) => {
					return {
						title: v.title,
						key: `${v.path}`,
					}
				})
				if (mapped.length) items.push(...mapped)
				return items
			},
		},
		methods: {
			dragStart(e, index) {
				e.stopPropagation()
				let columnItemElement = e.target.closest('.column-item')
				e.dataTransfer.setData('itemIndex', index)
				e.dataTransfer.setDragImage(columnItemElement, e.offsetX, e.offsetY)
			},
			drop(e, index) {
				e.preventDefault()
				const draggedItemIndex = e.dataTransfer.getData('itemIndex')
				const droppedElement = e.target.closest('.column-item')

				droppedElement.classList.add('swap-animation')
				setTimeout(() => {
					droppedElement.classList.remove('swap-animation')
				}, 500)

				this.$emit('swap-items', draggedItemIndex, index)

			},
			dragLeave(e) {
				let columnItemElement = e.target.closest('.column-item')

				columnItemElement.classList.add('swap-animation')
				setTimeout(() => {
					columnItemElement.classList.remove('swap-animation')
				}, 500)
			},
			remove() {
				this.$emit('remove', this.localData)
			},
		},
	}
</script>

<style lang="less">
	.column-header-container {
		border-bottom: 1px solid #e7ecef;
	}

	.column-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-left: 1px solid #e7ecef;
	}

	.alias-input {
		background-color: white;
		border-color: white;
		border-style: solid;
		outline: none;
		color: #1d407d;
		font-size: 12px;
		font-weight: 700;
		box-shadow: none;
		text-align: center;
		border-bottom: 1px solid transparent;
		transition: border 200ms ease-in-out;
	}

	.alias-input:focus {
		border-bottom: 1px solid #1d407d;
	}

	.remove-item-icon {
		color: red;
		border-radius: 50%;
		padding: 1px;
		background: transparent;
		width: 15px;
		height: 15px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.remove-item-icon:hover {
		color: white;
		background: red;
	}

	.move-item-icon {
		color: #1d407d;
		border-radius: 50%;
		padding: 1px;
		background: transparent;
		width: 15px;
		height: 15px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.move-item-icon:hover {
		/* background: black; */
		background: #1d407d;
		color: white;
	}

	.column-body-container {
		border-bottom: 1px solid #e7ecef;
	}

	.column-body {
		border-left: 1px solid #e7ecef;
		min-width: 210px;
	}

	.column-title {
		white-space: nowrap;
		font-weight: 700;
		text-align: center;
	}

	.column-aggregate {
		font-weight: 500;
		text-align: center;
	}

	.column-aggregate select {
		width: 90px;
	}

	.column-options {
		text-align: center;
	}

	.swap-animation {
		animation: 500ms showSwapAnimation ease-in-out;
	}

	@keyframes showSwapAnimation {
		from {
			background-color: rgb(161, 161, 161);
		}

		to {
			background-color: white;
		}
	}
</style>